import { render, staticRenderFns } from "./CoreShapedImage.vue?vue&type=template&id=7bba83e1&scoped=true&"
import script from "./CoreShapedImage.vue?vue&type=script&lang=ts&"
export * from "./CoreShapedImage.vue?vue&type=script&lang=ts&"
import style0 from "./CoreShapedImage.vue?vue&type=style&index=0&id=7bba83e1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bba83e1",
  null
  
)

export default component.exports